import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { guidanceStyles } from '../../styles/qaStyles';

/**
 * QA 안내 메시지 컴포넌트
 * @returns {JSX.Element} - 안내 메시지
 */
const QAGuidanceMessage = () => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} sx={guidanceStyles.container}>
      <Typography variant="body2" sx={guidanceStyles.text}>
        {t('analyze.chatPlaceholder')}
      </Typography>
    </Paper>
  );
};

export default QAGuidanceMessage; 